import { LogLevel } from '@nts/std/utility';

export const environment = {
    production: true,
    baseAppUrl: 'https://ntsitemservice.ntsinformatica.it',
    authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
    prefixApi: '/api',
    envType: 'DEV',
    appTitle: 'WebItem - DEV',
    appSubTitle: '',
    logLevel: LogLevel.All,
    isEnterpriseBarrierRequired: true
};
